import { createSelector } from '@reduxjs/toolkit';

import { PlateType } from '@paragon/contract-library';

import { RootState } from '../store';

// Takes the flat array of plate stock sizes and makes it a tree,
// grouped by plate manufacturer. For example:
// {
//   Mitek: ['M20', 'MT20'],
//   Simpson: ['AS20'],
// }

export type PlateTypesByManufacturer = {
  [PlateManufacturer: string]: readonly PlateType[];
};

export default createSelector(
  (state: RootState) => state.plateTypeProperties,
  (plateTypePropertiesList) => {
    const plateTypesByManufacturer: PlateTypesByManufacturer = {};
    for (const plateTypeProperties of plateTypePropertiesList) {
      plateTypesByManufacturer[plateTypeProperties.plateManufacturer] = [
        ...(plateTypeProperties.plateManufacturer in plateTypesByManufacturer
          ? plateTypesByManufacturer[plateTypeProperties.plateManufacturer]
          : []),
        plateTypeProperties.plateType,
      ];
    }

    return plateTypesByManufacturer;
  },
);
